import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/services/integration')({
  head: () => ({
    ...buildSeoHead({ path: '/services/integration', ...ROUTE_META['/services/integration'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Integration', path: '/services/integration' }])),
      jsonLdScript(buildWebPageSchema({ path: '/services/integration', ...ROUTE_META['/services/integration'] })),
    ],
  }),
});
